import {IState} from '../../core/IState';

export const SplashState: IState = {
    name: 'splash',
    url: '/',
    template: require('./splash.html'),
    data: {
        title: ''
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/splash/splashState.ts
 **/